import SectionNameCard from "../sectionnamecard/SectionNameCard";

const SectionNameSection = () => {
  const sectionName = [
    { name: "Connect an account", path: "/connect-new-account" },
    { name: "Reporting dashboard", path: "/reports" },
    { name: "Accounts summary", path: "/my-account" },
    { name: "Spending summary", path: "/spending-report" },
    { name: "Bill calendar", path: "/biller-calendarview" },
    { name: "Budget tracking", path: "/budget-tracking" },
    { name: "Budget setup", path: "/budget-setup" },
    { name: "Net worth goals", path: "/overview" },
    { name: "Retire savings", path: "/retirement-plan" },
  ];
  return (
    <>
      <div className="dashboard-section px-0 py-3 h-100">
        <div className="dashboard-section-header">
          <div>
            <h4>Section Name</h4>
          </div>
        </div>

        <div className="dashboard-tools-grid">
          {sectionName.map(({ name, path }) => {
            return <SectionNameCard key={name} sectionName={name} path={path} />;
          })}
        </div>
      </div>
    </>
  );
};

export default SectionNameSection;
